import { createSlice } from "@reduxjs/toolkit";
import { updateCustomer } from "../thunks/updateCustomerThunk";

const updateCustomerSlice = createSlice({
  name: "customer",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    customer: null,
  },
  reducers: {
    resetUpdateCustomerStatus: (state) => {
      state.status = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCustomer.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        state.customer = action.payload;
        state.status = "success";
        state.error = null;
      })
      .addCase(updateCustomer.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetUpdateCustomerStatus } = updateCustomerSlice.actions;
export default updateCustomerSlice.reducer;
